import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{justify-content:center;inline-size:100%;display:flex;position:fixed;inset-block-end:0;inset-inline-start:0}
`;
export default styles;